import { useSelector } from 'react-redux';

import { selectSelectedEntities } from '../../selectors/selected';

export const useSelectedEntityIds = (entityId?: number) => {
  const selected = useSelector(selectSelectedEntities);

  if (entityId) {
    return [entityId];
  }

  const ids = [];
  // eslint-disable-next-line guard-for-in
  for (const key in selected) {
    ids.push(selected[key].entityId);
  }

  return ids;
};
